import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import loader from "../loder.gif"
import Loader from 'react-js-loader'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import ReactSwitch from 'react-switch'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { edit } from 'brace'


export default function UpiSettings() {
  const [loading, setLoading] = useState(false)
  const [Admin, setAdmin] = useState([])
  const [allBank, setAllBank] = useState([])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [actionType, setActionType] = useState("")
  const [id, setId] = useState("")
  const [status, setCheckedAccount] = useState(true)
  const [bankName, setBankName] = useState('')
  const [accountHolderName, setAccountHolderName] = useState('')
  const [accountNumber, setAccountNumber] = useState('')
  const [ifscCode, setifscCode] = useState("")
  const [upiId, setUpiId] = useState("")
  const [upiHolderName, setupiHolderName] = useState('')
  const [maxLimit, setmaxLimit] = useState(10)
  const [minLimit, setminLimit] = useState(10)
  const [qrcodeImage, setqrcodeImage] = useState(null)
  const [type, setType] = useState("")

  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }


  const bankList = () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios
      .get(baseUrl + `/get/allbank`, { headers })
      .then(res => {
        setLoading(false)
        setAllBank(res.data?.data)
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  useEffect(() => {
    bankList()
    
  }, [])

  if (Admin === undefined) {
    return null
  }



  const handleSubmit1 = async (e) => {
    e.preventDefault();
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
    const formData = new FormData();
    formData.append('upiId', upiId);
    // formData.append('upiHolderName', upiHolderName);
    formData.append('maxLimit', maxLimit);
    formData.append('minLimit', minLimit);
    formData.append('status', status);
    formData.append('type', "upi");
    
    if (qrcodeImage) {
      formData.append('qrcodeImage', qrcodeImage);
    }
  
    try {
      let response;
      if (actionType === 'add') {
        response = await axios.post(
          baseUrl + `/bankdetail`,
          formData,
          { headers: { ...headers, 'Content-Type': 'multipart/form-data' } }
        );
        handleClose();
        bankList();
      } else if (actionType === 'edit') {
        response = await axios.put(
          baseUrl + `edit/bank/${id}`,
          { bankName,
          accountHolderName,
           accountNumber,
           ifscCode,
         upiId,
          upiHolderName,
        maxLimit,
          minLimit,
          status,},
          { headers}
        );
        handleClose();
        bankList();
      }
  
      if (response?.data?.status === 'success') {
        alert('Submission successful');
      } else {
        alert('Submission failed');
      }
    } catch (error) {
      console.error('API Error: ', error);
      alert('An error occurred while submitting');
    }
  };
  
  const deleteApi = async (id) => {
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
    try {
      // Await the axios call
      const response = await axios.put(
        baseUrl + `/delete/bank/${id}`, // Add the appropriate bank ID here
        {}, // Pass body if required, else keep it empty
        { headers } // Correct placement of headers
      );
  
      // Handle response
      if (response.data.status === 'success') {
        alert('Delete successfully');
        bankList()
      } else {
        alert('Not Delete');
      }
    } catch (error) {
      console.error(error);
      alert("Failed to delete bank. Please try again.");
    }
  };
  

  const handleChangeaccount = val => {
    setCheckedAccount(val)
  }

  const handleView = (type,bankUpi, id, bName, acNo, hname, ifsc, upi, max, min, status) => {
    setType(bankUpi)
    if (type == "add") {
      setActionType(type)
      handleShow()
    } else {
      console.log(acNo)
      setActionType(type)
      setId(id)
      handleShow()
      setBankName(bName);
      setAccountNumber(acNo);
      setAccountHolderName(hname);
      setifscCode(ifsc);
      setUpiId(upi);
      setmaxLimit(max);
      setminLimit(min);
      setCheckedAccount(status)


    }
  };

  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='text-uppercase font-weight-bold my-3'>all Admin list</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body  table_bg'>
              <div className='d-flex align-items-center justify-content-between'>
                <h4 className='dashboard_heading'>Upi Payment</h4>
                <button className='btn btn-info' onClick={() => handleView("add", "Upi")}>Add Upi</button>
              </div>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> UpiId </th>
                      <th> Qr Code </th>
                      <th> Limit </th>
                      <th> Status </th>
                    </tr>
                  </thead>
                  {allBank .filter((bank) => !bank.accountNumber) // Hide rows where accountNumber exists
  .map((bank, key) => (
                    <tbody key={key}>
                      <tr>
                        <td>{key + 1}</td>
                    
                        <td>{bank.upiId ? bank.upiId : '-----' }</td>
                        <td>
                        <a  href={`${baseUrl}/${bank.qrcodeImage}`} target="_blank">
                           <img
                              alt=''
                              src={baseUrl + `/${bank.qrcodeImage}`}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg';
                              }}
                              className=''
                              height={600}
                            /> </a></td>
                        <td>{bank?.minLimit} - {bank?.maxLimit}</td>
                        <td>
                          {/* <div className='badge badge-outline-success'>
                            <Button onClick={() => handleView("edit","Bank", bank?._id, bank?.bankName, bank?.accountNumber, bank?.accountHolderName, bank?.ifscCode, bank?.upiId, bank?.maxLimit, bank?.minLimit, bank?.status)}>Edit</Button>
                          </div> */}
                          <div className='badge badge-outline-success'>
                            <Button onClick={()=>deleteApi(bank?._id)}>Delete</Button>
                          </div>
                        </td>



                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal show"
          style={{ display: 'block', position: 'initial' }}
        >
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header >
              {/* <Modal.Title>Modal Heading</Modal.Title> */}
            </Modal.Header>
            <form
              action='gatewaysettings'
              className='form'
              onSubmit={handleSubmit1}
              method='patch'
              enctype='multipart/form-date'
            >
              <div className='form-row'>

                <div className='form-group col-md-12'>
                  <Card>
                    <Card.Body>
                      <h4 className='dashboard_small_heading_blue'>
                        Upi Deposit
                      </h4>
                      <Container>

                        <Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col className='col-6'>Upi Deposit</Col>
                          <Col sm={2}>
                            {' '}
                            <ReactSwitch
                              checked={status}
                              onChange={handleChangeaccount}
                              style={{ display: 'none' }}
                            />
                          </Col>
                        </Row>
     

                       
<Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col className='col-6'>Upi Id</Col>
                          <Col className='col-6'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={upiId}
                              onChange={e =>
                                setUpiId(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter UPI ID'
                            />
                          </Col>
                        </Row>
                        <Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col className='col-6'>Min-Limit</Col>
                          <Col className='col-6'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={minLimit}
                              onChange={e =>
                                setminLimit(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter Min-Limit'
                            />
                          </Col>
                        </Row>
                        <Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col className='col-6'>Max-Limit</Col>
                          <Col className='col-6'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={maxLimit}
                              onChange={e =>
                                setmaxLimit(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter Max-Limit'
                            />
                          </Col>
                        </Row>
                        {actionType !== 'edit' && type === "Upi" && (
  <Row style={{ marginRight: '4.25rem', marginTop: '10px' }}>
    <Col className='col-6'>Qr Code</Col>
    <Col className='col-6'>
      <input
        type='file'
        accept='image/*'
        name='rkludoPopular'
        onChange={e => setqrcodeImage(e.target.files[0])}
        style={{ width: '200px' }}
      />
    </Col>
  </Row>
)}

                        <Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col sm={6}>
                            <button type='submit' className='btn btn-dark'>
                              submit
                            </button>
                          </Col>
                        </Row>
                      </Container>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </form>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              {/* <Button variant="primary" onClick={handleClose}>
      Save Changes
    </Button> */}
            </Modal.Footer>
          </Modal>
        </div>

      </div>
    </>
  )
}
